import React from "react";

export const REG_STATUS_OPTIONS = ["pending_payment", "confirmed", "cancelled", "annulled"];
export const SPONSOR_STATUS_OPTIONS = ["pending_payment", "confirmed", "cancelled"];
export const DAYS = [9, 10, 11, 12, 13];

export const logError = (msg, e) => { if (process.env.NODE_ENV === "development") console.error(msg, e); };
export const sponsorState = (s) => (["cancelled", "pending_payment"].includes(s.status) ? s.status : "confirmed");
export const sponsorBadge = (s) => (s.payment_status === "paid" || s.status === "cancelled" ? s.status.replace(/_/g, " ") : "pending payment");
export const fmtTs = (ts, len = 16) => (ts || "").slice(0, len).replace("T", " ");

const REG_STATUS_CLS = { confirmed: "bg-[#008057] text-white", pending_payment: "bg-amber-100 text-amber-800" };
export const regStatusCls = (status) => REG_STATUS_CLS[status] || "bg-red-100 text-red-700";

export function sponsorStatusCls(s) {
  if (s.payment_status === "paid") return "bg-[#008057] text-white";
  if (s.status === "cancelled") return "bg-red-100 text-red-700";
  return "bg-amber-100 text-amber-800";
}

export function sponsorDisplayName(s) {
  if (s.anonymous) return "Anonymous";
  if (s.acknowledgment_name) return s.acknowledgment_name;
  if (s.sponsor_type === "corporate") return s.sponsor.company;
  return `${s.sponsor.first_name || ""} ${s.sponsor.last_name || ""}`;
}

const ACTION_LABELS = { manually_confirmed: "Confirmed", cancelled: "Cancelled", annulled: "Annulled", edited: "Edited" };

export function LastAdminAction({ order }) {
  const notes = order.admin_notes || [];
  if (!notes.length) return <span className="text-slate-300">—</span>;
  const n = notes[notes.length - 1];
  const who = (n.actor || "").split("@")[0] || n.actor;
  const label = ACTION_LABELS[n.action] || (n.action || "").replace(/_/g, " ");
  return (
    <span className="text-xs">
      <span className="font-semibold text-[#03281B]">{label}</span>
      <span className="text-slate-400"> by {who}</span>
      {n.ts && <span className="block text-[10px] text-slate-400">{fmtTs(n.ts)}</span>}
    </span>
  );
}

const TONES = { green: "text-[#008057] bg-[#F2F8F5]", gold: "text-[#B8860B] bg-amber-50", amber: "text-amber-700 bg-amber-50", red: "text-red-600 bg-red-50" };

export function Stat({ icon: Icon, label, value, tone = "green" }) {
  return (
    <div className="rounded-2xl bg-white border border-[#E2EBF0] p-5 shadow-sm">
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${TONES[tone]}`}><Icon size={20} /></div>
      <div className="font-display text-3xl font-extrabold text-[#03281B] mt-3">{value}</div>
      <div className="text-sm text-slate-500">{label}</div>
    </div>
  );
}

export const PageTitle = ({ children }) => <h1 className="font-display text-3xl font-extrabold text-[#03281B]">{children}</h1>;
